<template>
    <v-card class="pa-4">
        <v-dialog v-model="showParentDialog" width="800px">
            <v-overlay :value="isLoading">
                <v-progress-circular indeterminate
                                     color="primary"
                                     :size="70"
                                     :width="7"></v-progress-circular>
            </v-overlay>
            <v-card class="search-modal">
                <h2 class="mb-3">Parent Search</h2>
                <v-form @submit.prevent="search">
                    <v-row>
                        <v-col>
                            <v-text-field outlined
                                          v-model="parentMemberId"
                                          label="Member ID" />
                        </v-col>
                        <v-col>
                            <v-text-field outlined
                                          v-model="parentFirstName"
                                          label="First Name" />
                        </v-col>
                        <v-col>
                            <v-text-field outlined
                                          v-model="parentLastName"
                                          label="Last Name" />
                        </v-col>
                        <v-col>
                            <v-btn v-on:click="parentSearch" color="primary">
                                <v-icon> mdi-magnify </v-icon>
                                Search
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
                <p v-if="!!searchResultsParent && !searchResultsParent.length && hasSearchedParent">
                    No Matching People Found
                </p>
                <v-data-table v-if="!!searchResultsParent && searchResultsParent.length"
                              :headers="headersParents"
                              :items="searchResultsParent"
                              hide-default-header
                              hide-default-footer>
                    <template v-slot:item="row">
                        <tr>
                            <td>
                                <a :href="`/admin/people/${row.item.personId}`" target="_blank" v-if="row.item.memberId != null">
                                   {{row.item.memberId}}
                                </a>
                            </td>
                            <td>
                                <a :href="`/admin/people/${row.item.personId}`" target="_blank">
                                    {{ row.item.firstName }} {{row.item.lastName}}
                                </a>
                            </td>
                            <td>
                                <font-awesome-icon icon="id-card" :color="row.item.isActiveMember == false ? 'red' : 'green'" />
                                
                            </td>
                            <td>
                                <a v-on:click="parentAdd(row.item)">
                                    <font-awesome-icon icon="plus" color="blue" />
                                </a>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showValidationDialog">
            <v-card class="search-modal">
                <h2>Validation Results</h2>
                <v-form class="search-form">
                    <v-alert v-if="!!validationResult && !!validationResult.errors && validationResult.errors.length > 0" type="error">
                        <pre>{{ validationResult.errors.join("\r\n") }}</pre>
                    </v-alert>
                    <v-alert v-if="!!validationResult && validationResult.warnings && validationResult.warnings.length > 0" type="warning" outlined>
                        <pre>{{ validationResult.warnings.join("\r\n") }}</pre>
                    </v-alert>
                    <v-btn large
                           color="primary"
                           width="125px"
                           :disabled="!validationResult.canBeSaved"
                           v-on:click="saveChanges">
                        <v-icon v-if="!validationResult.canBeSaved">mdi-alert</v-icon>
                        Save
                    </v-btn>
                </v-form>
            </v-card>
        </v-dialog>
        <v-row class="mb-3">
            <h3 v-if="juniorHandlerInfo.personId">Junior Handler Details - {{juniorHandlerInfo.personId}}</h3>
            <h3 v-else>Create New Junior Handler</h3>
        </v-row>
        <br />

        <v-row>
            <v-textarea :disabled="!isEditMode"
                        :visible="!isEditMode"
                        outlined
                        auto-grow
                        clearable
                        rows="1"
                        v-model="juniorHandlerInfo.adminNotes"
                        label="Description of changes (required)" />
            <v-btn class="ml-1 mr-1"
                   :disabled="isEditMode && (!juniorHandlerInfo.adminNotes || /^\s*$/.test(juniorHandlerInfo.adminNotes))"
                   color="primary"
                   @click="toggleEditMode">
                {{ isEditMode ? "Save" : "Edit" }}
            </v-btn>
        </v-row>

        <v-row class="mb-3">

            <v-col>
                <v-card class="pa-2" elevation="2">
                    <v-card-title class="text-h6">Age Group</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <DatepickerFormatted :disabled="!isEditMode"
                                            :date="juniorHandlerInfo.birthdate"
                                            label="DOB*" class="mr-2"
                                            v-on:updateDates="updateDates($event, 'birthdate')" />
                                <v-select v-model="juniorHandlerInfo.ageGroup"
                                          :items="ageGroupDescriptions" class="mr-2"
                                          :disabled="!isEditMode"
                                          label="Age Group*"></v-select>

                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>

            </v-col>
            <v-col>
                <v-card class="pa-2" elevation="2">
                    <v-card-title class="text-h6">
                        Region &amp; State
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-select v-model="juniorHandlerInfo.region"
                                          :items="regionDescriptions" class="mr-2"
                                          :disabled="!isEditMode"
                                          label="Region*"></v-select>
                                <v-text-field v-model="juniorHandlerInfo.state"
                                              label="State*" :rules="[v => (v || '' ).length <= 2 || 'State is limited to 2 chars']"
                                              :disabled="!isEditMode" />


                            </v-col>
                        </v-row>
                    </v-card-text>


                </v-card>

            </v-col>


        </v-row>

        <v-row class="mb-3">

            <v-col>
                <v-card class="pa-2" elevation="2">
                    <v-card-title class="text-h6">
                        Parent 1 <font-awesome-icon icon="link" color="green" size="xs" class="ml-2" v-if="juniorHandlerInfo.parent1!=null && juniorHandlerInfo.parent1.personId != null && juniorHandlerInfo.parent1.personId != -1" />
                        <span v-if="juniorHandlerInfo.parent1!=null && juniorHandlerInfo.parent1.memberId != null && juniorHandlerInfo.parent1.memberId.length > 0" class="ml-1"> (Member ID:{{juniorHandlerInfo.parent1.memberId}})</span>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-text-field v-model="juniorHandlerInfo.parent1.firstName"
                                              label="First Name" :rules="[v => (v || '' ).length <= 50|| 'Name is limited to 50 chars']"
                                              :disabled="!parentCanEditName(1)" />
                                <v-text-field v-model="juniorHandlerInfo.parent1.lastName"
                                              label="Last Name" :rules="[v => (v || '' ).length <= 50|| 'Name is limited to 50 chars']"
                                              :disabled="!parentCanEditName(1)" />

                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <div class="text-center mb-6">
                                    <div class="my-2">

                                        <v-btn color="primary" elevation="2"
                                               v-on:click="toggleParentSearchDialog(1)"
                                               :disabled="!isEditMode">
                                            Parent Search
                                        </v-btn>
                                        <v-btn color="primary" elevation="2" class="ml-2"
                                               v-on:click="clearParent(1)" :disabled="!isEditMode">
                                            Clear
                                        </v-btn>

                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

            </v-col>
            <v-col>
                <v-card class="pa-2" elevation="2">
                    <v-card-title class="text-h6">
                        Parent 2 <font-awesome-icon icon="link" color="green" size="xs" class="ml-2" v-if="juniorHandlerInfo.parent2!=null && juniorHandlerInfo.parent2.personId != null && juniorHandlerInfo.parent2.personId != -1" />
                        <span v-if="juniorHandlerInfo.parent2!=null && juniorHandlerInfo.parent2.memberId != null && juniorHandlerInfo.parent2.memberId.length > 0" class="ml-1"> (Member ID:{{juniorHandlerInfo.parent2.memberId}})</span>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>

                                <v-text-field v-model="juniorHandlerInfo.parent2.firstName"
                                              label="First Name" :rules="[v => (v || '' ).length <= 50 || 'Name is limited to 50 chars']"
                                              :disabled="!parentCanEditName(2)" />
                                <v-text-field v-model="juniorHandlerInfo.parent2.lastName"
                                              label="Last Name" :rules="[v => (v || '' ).length <= 50|| 'Name is limited to 50 chars']"
                                              :disabled="!parentCanEditName(2)" />


                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <div class="text-center mb-6">
                                    <div class="my-2">

                                        <v-btn color="primary" elevation="2"
                                               v-on:click="toggleParentSearchDialog(2)"
                                               :disabled="!isEditMode">
                                            Parent Search
                                        </v-btn>
                                       
                                            <v-btn color="primary" elevation="2" class="ml-2" :disabled="!isEditMode"
                                                   v-on:click="clearParent(2)">
                                                Clear
                                            </v-btn>
                                       
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>


                </v-card>

            </v-col>


        </v-row>

        <div v-if="juniorHandlerInfo.personId">
            <v-divider></v-divider>
            <v-row>
                <v-col class="mt-4">
                    <v-tabs v-model="tab">
                        <v-tab key="titledDogs">
                            Titled Dogs
                        </v-tab>
                        <v-tab key="handlingScores">
                            Handling Scores
                        </v-tab>
                        <v-tab key="stockdogScores">
                            Stockdog Scores
                        </v-tab>
                        <v-tab key="obedienceScores">
                            Obedience Scores
                        </v-tab>
                        <v-tab key="trackingScores">
                            Tracking Scores
                        </v-tab>
                        <v-tab key="rallyScores">
                            Rally Scores
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item key="titledDogs">
                            <titled-dogs :personId="personId" :titlesTypes="titlesTypes" />
                        </v-tab-item>
                        <v-tab-item key="handlingScores">
                            <junior-handling-scores :personId="personId" :classes="handlingClasses"/>
                        </v-tab-item>
                        <v-tab-item key="stockdogScores">
                            <v-row>
                                <v-col>
                                    <h1>Open:</h1>
                                    <JuniorStockdogOpenScores :personId="personId" :classes="stockdogOpenClasses" />
                                </v-col>
                                <v-col>
                                    <h1>Working:</h1>
                                    <JuniorStockdogStandardScores :personId="personId" :classes="stockdogStandardClasses" />
                                </v-col>
                            </v-row>
                        </v-tab-item>
                        <v-tab-item key="obedienceScores">
                            <JuniorObedienceScores :personId="personId" :classes="obedienceClasses" />
                        </v-tab-item>
                        <v-tab-item key="trackingScores">
                            <JuniorTrackingScores :personId="personId" :classes="trackingClasses" />
                        </v-tab-item>
                        <v-tab-item key="rallyScores">
                            <JuniorRallyScores :personId="personId" :classes="rallyClasses" />
                        </v-tab-item>
                    </v-tabs-items>
                </v-col>
            </v-row>
        </div>

        <div class="mt-3">
            <v-divider class="my-3"></v-divider>
            <v-row class="pt-0 mt-0">
                <v-col>
                    <h3>Notes</h3>
                </v-col>

            </v-row>

            <v-row>

                <v-textarea disabled
                            @input="updateText('notes', $event)"
                            :value="juniorHandlerInfo.notes"
                            outlined
                            rows="1"
                            auto-grow></v-textarea>

            </v-row>
        </div>
        <v-snackbar v-model="showInfoMessage" title color="green">
            {{ infoMessage }}
            <template v-slot:action="{ attrs }">
            <v-btn color="primary" text v-bind="attrs" @click="showInfoMessage = false">
                Close
            </v-btn>
            </template>
        </v-snackbar>
        <v-snackbar v-model="showErrorMessage" title color="red">
            {{ errorMessage }}
            <template v-slot:action="{ attrs }">
            <v-btn color="primary" text v-bind="attrs" @click="showErrorMessage = false">
                Close
            </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
import TitledDogs from '@/components/Admin/JuniorHandler/TitledDogs.vue';
import JuniorHandlingScores from '@/components/Admin/JuniorHandler/JuniorHandlingScores.vue';
import JuniorRallyScores from '@/components/Admin/JuniorHandler/JuniorRallyScores.vue'
import JuniorTrackingScores from '@/components/Admin/JuniorHandler/JuniorTrackingScores.vue';
import JuniorObedienceScores from '@/components/Admin/JuniorHandler/JuniorObedienceScores.vue';
import JuniorStockdogOpenScores from '@/components/Admin/JuniorHandler/JuniorStockdogOpenScores.vue';
import JuniorStockdogStandardScores from '@/components/Admin/JuniorHandler/JuniorStockdogStandardScores.vue';
import DatepickerFormatted from "@/components/common/inputs/DatepickerFormatted.vue";

import { ValueGroup } from '@/services/adminService';
import lookupsService from '@/services/admin/lookupsService';
import juniorHandlerService from '@/services/admin/juniorHandlerService';

import { Messages } from "@/constants";
import { JuniorHandler, Parent } from '@/types/admin/JuniorHandler';
import { JrHandlerScoreType } from "@/types/admin/JuniorHandler";

export default Vue.extend({
    components: { 
        TitledDogs, 
        JuniorHandlingScores, JuniorRallyScores, JuniorTrackingScores, JuniorObedienceScores, 
        JuniorStockdogOpenScores, JuniorStockdogStandardScores,
        DatepickerFormatted 
    },
    name: "JuniorHandlerDetails",
    data: function () {
        return {
            juniorHandlerInfo: {
                parent1: {} as Parent,
                parent2: {} as Parent
            } as JuniorHandler,
            tab: null,
            isEditMode: false,
            showValidationDialog: false,
            validationResult: {} as any,
            searchResults: [] as any[],
            ageGroups: [] as ValueGroup[],
            ageGroupDescriptions: [] as string[],
            regions: [] as ValueGroup[],
            regionDescriptions: [] as string[],
            reloadPage: false,
            showParentDialog: false,
            hasSearched: false,
            hasSearchedParent: false,
            searchResultsParent: [] as Parent[],
            activeParentIndex: -1,
            parentFirstName: "",
            parentLastName:"",
            parentMemberId: "",
            headersParents: [
                { text: "Member ID", align: "left", value: "memberId" },
                { text: "First Name", align: "left", value: "firstName" },
                { text: "Last Name", align: "left", value: "lastName" },
                { text: "Active", align: "left", value: "isActive" },
            ],
            isLoading: false,
            titlesTypes: [] as any[],
            handlingClasses: [] as any[],
            obedienceClasses: [] as any[],
            stockdogOpenClasses: [] as any[],
            stockdogStandardClasses: [] as any[],
            trackingClasses: [] as any[],
            rallyClasses: [] as any[],
            errorMessage: '',
            infoMessage: '',
            showErrorMessage: false,
            showInfoMessage: false
        }
    },
    created: function () {
        if (this.personId) {
            juniorHandlerService.getJuniorHandlerById(this.personId).then((res: JuniorHandler) => {
                if (res) {
                    this.juniorHandlerInfo = res;
                    this.reloadPage = false;
                } else {
                    this.juniorHandlerInfo = {} as JuniorHandler;
                    this.juniorHandlerInfo.parent1 = {} as Parent;
                    this.juniorHandlerInfo.parent2 = {} as Parent;
                    this.isEditMode = true;
                    this.reloadPage = true;
                }
            }).catch(e => {
                this.juniorHandlerInfo = {} as JuniorHandler;
                this.juniorHandlerInfo.parent1 = {} as Parent;
                this.juniorHandlerInfo.parent2 = {} as Parent;
                this.juniorHandlerInfo.personId = this.$props.personId;
                this.reloadPage = true;
            })
        }
        else {
            this.juniorHandlerInfo = {} as JuniorHandler;
            this.juniorHandlerInfo.parent1 = {} as Parent;
            this.juniorHandlerInfo.parent2 = {} as Parent;
            this.isEditMode = true;
            this.reloadPage = true;
        }

        juniorHandlerService.getJuniorHandlerAgeGroups().then((res: any) => {
            this.ageGroups = res;
            this.ageGroupDescriptions.push('');
            for (let i = 0; i < this.ageGroups.length; i++) {
                this.ageGroupDescriptions.push(this.ageGroups[i].description);
            }
        });

        juniorHandlerService.getJuniorHandlerRegions().then((res: any) => {
            this.regions = res;
            this.regionDescriptions.push('');
            for (let i = 0; i < this.regions.length; i++) {
                this.regionDescriptions.push(this.regions[i].description);
            }
        });

        lookupsService
            .getProgramTitlesTypes('') 
            .then((res) => {
                this.titlesTypes = res; 
            });

        juniorHandlerService
            .getJuniorHandlerProgramClasses(JrHandlerScoreType.Handling) 
            .then((res) => {
                this.handlingClasses = res; 
            });

        juniorHandlerService
            .getJuniorHandlerProgramClasses(JrHandlerScoreType.Obedience) 
            .then((res) => {
                this.obedienceClasses = res; 
            }); 

        juniorHandlerService
            .getJuniorHandlerProgramClasses(JrHandlerScoreType.StockdogOpen) 
            .then((res) => {
                this.stockdogOpenClasses = res; 
            });  

        juniorHandlerService
            .getJuniorHandlerProgramClasses(JrHandlerScoreType.StockdogStandard) 
            .then((res) => {
                this.stockdogStandardClasses = res; 
            });    

        juniorHandlerService
            .getJuniorHandlerProgramClasses(JrHandlerScoreType.Tracking) 
            .then((res) => {
                this.trackingClasses = res; 
            }); 

        juniorHandlerService
            .getJuniorHandlerProgramClasses(JrHandlerScoreType.Rally) 
            .then((res) => {
                this.rallyClasses = res; 
            });       
    },
    watch: {
        personId: function (newVal: String) {
        juniorHandlerService
            .getJuniorHandlerById(this.personId)
            .then((res) => {
                this.juniorHandlerInfo = res;
            });
        },
    },
    methods: {
        reloadData: function () {
            if (this.personId) {
                juniorHandlerService.getJuniorHandlerById(this.personId).then((res: JuniorHandler) => {
                    if (res) {
                        this.juniorHandlerInfo = res;
                    } else {
                        this.juniorHandlerInfo = {} as JuniorHandler;
                        this.isEditMode = true;
                    }
                }).catch(e => {
                    this.juniorHandlerInfo = {} as JuniorHandler;
                    this.juniorHandlerInfo.personId = this.$props.personId;
                })
            }
            else {
                this.juniorHandlerInfo = {} as JuniorHandler;
                this.isEditMode = true;
            }
            this.showValidationDialog = false;
            this.errorMessage = '';
            this.showErrorMessage = false;
            this.validationResult = {};
        },
        validateAndConfirmSavingChanges: function () {
            this.errorMessage = "";
            this.showErrorMessage = false;
         
            if (!this.validateValues()) {
                this.isEditMode = false; //will toggle it back to edit mode
                return false;
            }
            this.updateRegionsAgeGroups();
            this.juniorHandlerInfo.personId = this.$props.personId;
            this.saveChanges();

        },
        toggleEditMode: function () {
            if (this.isEditMode) {
                this.validateAndConfirmSavingChanges();
            }
            this.isEditMode = !this.isEditMode;
        },
        updateDates: function (val: any, key: string) {
            this.$data.juniorHandlerInfo[key] = val?.date;
            this.$data.juniorHandlerInfo = Object.assign({}, this.$data.juniorHandlerInfo);
        },
        saveChanges: function () {
            this.errorMessage = "";
            this.showErrorMessage = false;
            this.showValidationDialog = false;
            this.$store.dispatch("changeLoaderStatus", true);
            juniorHandlerService
                .editJuniorHandler(this.juniorHandlerInfo)
                .then((res: any) => {
                    if (res.success) {
                        this.reloadData();
                        if (this.reloadPage) {
                            window.location.reload();
                        }
                        this.infoMessage = Messages.SaveSuccessful;
                        this.showInfoMessage = true;
                    } else {              
                        this.errorMessage = Messages.SaveError + " " + res.messages.join(', ');
                        this.showErrorMessage = true;
                    }
                })
                .catch((e) => {                  
                    this.errorMessage = Messages.SaveError;
                    this.showErrorMessage = true;
                })
                .finally(() => this.$store.dispatch("changeLoaderStatus", false));
        },
        updateRegionsAgeGroups: function () {
            if (this.juniorHandlerInfo.ageGroup != null) {
                var ageGroup = this.ageGroups.find((x: ValueGroup) => x.description == this.juniorHandlerInfo.ageGroup);
                if (ageGroup != null) {
                    this.juniorHandlerInfo.ageGroupId = ageGroup.id;
                }
            }
            if (this.juniorHandlerInfo.region != null) {
                var region = this.regions.find((x: ValueGroup) => x.description == this.juniorHandlerInfo.region);
                if (region != null) {
                    this.juniorHandlerInfo.regionId = region.id;
                }
            }
        },
        validateValues: function () {
            if (this.juniorHandlerInfo.birthdate == null) {
                this.errorMessage = "DOB is required.";
                this.showErrorMessage = true;
                return false;
            }
            if (!this.juniorHandlerInfo.ageGroup || this.juniorHandlerInfo.ageGroup.length === 0) {
                this.errorMessage = "Age Group is required.";
                this.showErrorMessage = true;
                return false;
            }
            if (!this.juniorHandlerInfo.region || this.juniorHandlerInfo.region.length === 0) {
                this.errorMessage = "Region is required.";
                this.showErrorMessage = true;
                return false;
            }
            if (!this.juniorHandlerInfo.state || this.juniorHandlerInfo.state.length === 0 || /^\s*$/.test(this.juniorHandlerInfo.state)) {
                this.errorMessage = "State is required.";
                this.showErrorMessage = true;
                return false;
            }
            else {
                if (this.juniorHandlerInfo.state.length > 2) {
                    this.errorMessage = "State is too long.";
                    this.showErrorMessage = true;
                    return false;
                }
            }
            if (this.juniorHandlerInfo.parent1 != null) {
                if (this.juniorHandlerInfo.parent1.personId == null || this.juniorHandlerInfo.parent1.personId == -1) {
                    if (this.juniorHandlerInfo.parent1.firstName != null) {
                        if (this.juniorHandlerInfo.parent1.firstName.length > 50) {
                            this.errorMessage = "Parent 1 First Name is too long.";
                            this.showErrorMessage = true;
                            return false;
                        }
                    }
                    if (this.juniorHandlerInfo.parent1.lastName != null) {
                        if (this.juniorHandlerInfo.parent1.lastName.length > 50) {
                            this.errorMessage = "Parent 1 Last Name is too long.";
                            this.showErrorMessage = true;
                            return false;
                        }
                    }
                }
            }
            if (this.juniorHandlerInfo.parent2 != null) {
                if (this.juniorHandlerInfo.parent2.personId == null || this.juniorHandlerInfo.parent2.personId == -1) {
                    if (this.juniorHandlerInfo.parent2.firstName != null) {
                        if (this.juniorHandlerInfo.parent2.firstName.length > 50) {
                            this.errorMessage = "Parent 2 First Name is too long.";
                            this.showErrorMessage = true;
                            return false;
                        }
                    }
                    if (this.juniorHandlerInfo.parent2.lastName != null) {
                        if (this.juniorHandlerInfo.parent2.lastName.length > 50) {
                            this.errorMessage = "Parent 2 Last Name is too long.";
                            this.showErrorMessage = true;
                            return false;
                        }
                    }
                }
            }

            return true;
           
        },
        toggleParentSearchDialog: function (forParent: number) {
            this.activeParentIndex = forParent;
            this.showParentDialog = !this.showParentDialog;
        },
        parentSearch: function () {
            this.isLoading = true;
            this.hasSearchedParent = false;
            juniorHandlerService
                .searchJuniorHandlerParent({
                    memberId: this.parentMemberId,
                    firstName: this.parentFirstName,
                    lastName: this.parentLastName,
                    jrHandlerPersonId: this.personId,
                }).then((response: any) => {
                    this.searchResultsParent = response.data;
                    this.hasSearchedParent = true;
                });
            this.isLoading = false;

        },
        parentAdd: function (row: Parent) {
            if (this.activeParentIndex == 1) {
                this.juniorHandlerInfo.parent1 = row;
            }
            else {
                this.juniorHandlerInfo.parent2 = row;
            }
            this.showParentDialog = false;
            this.clearSearch();
           
        },
        parentCanEditName: function (forParent: number) {
            if (!this.isEditMode) {
                return false;
            }

            if (forParent == 1)
            {
                return (this.juniorHandlerInfo.parent1 == null || (this.juniorHandlerInfo.parent1.personId == null || this.juniorHandlerInfo.parent1.personId == -1));
            }
            else {
                return (this.juniorHandlerInfo.parent2 == null || (this.juniorHandlerInfo.parent2.personId == null || this.juniorHandlerInfo.parent2.personId == -1));
            }
        },
        clearParent: function (forParent: number) {
            if (forParent == 1) {
                this.juniorHandlerInfo.parent1.firstName = "";
                this.juniorHandlerInfo.parent1.lastName = "";
                this.juniorHandlerInfo.parent1.personId = -1;
                this.juniorHandlerInfo.parent1.memberId ="";
                
            }
            else {
                this.juniorHandlerInfo.parent2.firstName = "";
                this.juniorHandlerInfo.parent2.lastName = "";
                this.juniorHandlerInfo.parent2.personId = -1;
                this.juniorHandlerInfo.parent2.memberId = "";
            }
        },
        clearSearch: function () {
            this.parentFirstName = "";
            this.parentLastName = "";
            this.parentMemberId = "";
            this.searchResultsParent = [] as Parent[];
        },
    },
    props: {
        personId: { type: Number },
    },
})
</script>